export enum ReportTypeEnum {
    Analysis,
    Auditor
  }